import React from "react";
import { HashTag, PageRoute, VerifyModalI } from "../models/enums";
import { UserI } from "../typings/interfaces";
import styles from "./getVerifyModalContent.scss"
export const getVerifyModalContent = (user: UserI): VerifyModalI => {
  if (user.hasInvalidUsername) {
    return {
      heading: "Potrebna je promjena korisničkog imena",
      content: "Za slanje poruka i postavljanje oglasa, vaše korisničko ime mora sadržavati samo dopuštene znakove.\nVaše trenutno korisničko ime sadrži nedopuštene znakove, pa ga je potrebno promijeniti prije nastavka.",
      redirectPath: PageRoute.profile,
    };
  }

  var isCroatianAccount = user.countryId === "1d0ed9f8-c5b3-47f8-8ca1-7feb948d5aef";
  var hasRequiredIdentity = (isCroatianAccount && user.isIdentityNumberRequired) ? !!user.identityNumber : true;
  var hasDominantCategory = user.legalEntity ? (user.dominantCategories && user.dominantCategories.length > 0) : true;
  var hasBasicProfileData = isCroatianAccount
    ? (user.firstName && user.lastName && user.email && user.cityId && user.settlementId && user.street && user.zipCode && hasRequiredIdentity && hasDominantCategory)
    : (user.firstName && user.lastName && user.email && user.street && user.zipCode && hasDominantCategory);

  if (user.phoneNumberVerificationPending && hasBasicProfileData) {
    return {
      heading: "Obavijest",
      // content: "Verifikacija vašeg broja je u tijeku.\n\n\n",
      content: (
        <div>
          <p>Verifikacija broja je u tijeku.</p>
          <p>Za bržu obradu nazovite nas s broja koji želite verificirati na broj: </p>
          <p>
            <a href="tel:+385913339511" className={styles.phoneLink}>
              +385 91 333 9511
            </a>

          </p>
          <p>Radnim danom od 8 do 16 sati.</p>
        </div>
      ),
      redirectPath: "/",
      okText: "Razumijem",
      cancelText: "Zatvori",
      noRedirect: true,
    };
  }

  if (!user.hasVerifiedPhoneNumber && hasBasicProfileData) {
    return {
      heading: "Obavijest",
      content: "Za slanje poruka i predaju oglasa, još samo trebate verificirati barem jedan broj telefona.\n\nŽelite li to učiniti sada?",
      redirectPath: `${PageRoute.profile}${HashTag.focusPhone}`,
      okText: "Želim",
      cancelText: "Odustani",
    };
  }

  return {
    heading: "Obavijest",
    content: "Za slanje poruka i postavljanje oglasa, vaš profil mora sadržavati osnovne podatke i barem jedan verificirani broj telefona. Želite li sada dopuniti svoj profil?",
    redirectPath: PageRoute.profile,
  };
};



// WEBPACK FOOTER //
// ./src/services/getVerifyModalContent.tsx